/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect } from 'react';
import Colors from "constants/Colors";
import Icon from "components/Icon";
import HasPermission from 'components/HasPermission/index';
import { TooltipBox, TooltipCard, TooltipText } from './styles';
import { Col, Row } from "components/Grid";
import { useHistory } from 'react-router-dom';

function ListEnquiryButtons(props) {
  const [isDeclined, setIsDeclined] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (props.listItem) {
      if (props.listItem.idDomainStatusOper === 2) setIsDeclined(true)
    }
  }, [])

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
      <Row className="align-items-center justify-content-start" style={{ width: props.width || 130 }}>
        <HasPermission permission={props.icons.includes('edit')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="edit"
                onClick={() => props.editRoute(props.listItem.idOperation, props.listItem.idProduct)}
                style={props.editPermission ? icon : opacityAllowed} />
            </TooltipText>
            <TooltipBox>
              {props.iconTooltips[581]}
            </TooltipBox>
          </TooltipCard>
        </HasPermission>

        <HasPermission permission={props.icons.includes('folder')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="folder"
                onClick={() => props.toDocument()} />
            </TooltipText>
            <TooltipBox>
              Documents
            </TooltipBox>
          </TooltipCard>
        </HasPermission>

        <HasPermission permission={props.icons.includes('decline')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="lost3"
                onClick={() => {
                  if (props.listItem.isRejected || !props.listItem.isEdit) {
                    return;
                  }
                  props.createModalBody("lost", props.listItem);
                }}
                style={props.listItem.isRejected ? opacity : icon}
              />
            </TooltipText>
            <TooltipBox>
              {props.iconTooltips[583]}
            </TooltipBox>
          </TooltipCard>
        </HasPermission>

        <HasPermission permission={props.icons.includes('endrosement') && props.createEndorsementPermission}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name={props.createPermission && props.listItem.canCreateEndorsement ? "endorsementSelect" : "endorsementNotSelect"}
                onClick={() => props.createPermission && props.listItem.canCreateEndorsement ? props.newEndorsement(props.listItem.idOperation) : null}
                style={{ alignSelf: "center", cursor: props.createPermission && props.listItem.canCreateEndorsement ? "pointer" : "not-allowed" }}
              />
            </TooltipText>
            <TooltipBox>
              {props.iconTooltips[601]}
            </TooltipBox>
          </TooltipCard>
        </HasPermission>
      </Row>

      <Row className="align-items-center  justify-content-start" style={{ width: props.width || 130 }}>
      <HasPermission permission={props.icons.includes('approve')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="check-ok"
                onClick={() => {
                  if (props.isClient || isDeclined || !props.listItem.hasPermission || props.listItem.isRejected || !props.listItem.isApproved) {
                    return;
                  }
                  props.createModalBody("approve", props.listItem);
                }}
                style={props.isClient || isDeclined || !props.listItem.hasPermission ? opacity : props.listItem.isRejected ? opacity
                  : props.listItem.isApproved
                    ? icon
                    : opacity}>
              </Icon>
            </TooltipText>
            <TooltipBox>
              {props.iconTooltips[584]}
            </TooltipBox>
          </TooltipCard>
        </HasPermission>

        <HasPermission permission={props.icons.includes('update-schedule')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="schedule-updated"
                onClick={() => !props.listItem.isMasterPolicy && props.listItem.showIconUpdatedSchedule && history.push(`/broking/market-composition-updated-schedule/${props.listItem.idOperation}`)}
                style={{ alignSelf: "center", cursor: props.listItem.showIconUpdatedSchedule ? "pointer" : "not-allowed", opacity: props.listItem.isMasterPolicy || !props.listItem.showIconUpdatedSchedule ? 0.5 : 1 }}
              />
            </TooltipText>
            <TooltipBox>
              Schedule Update
            </TooltipBox>
          </TooltipCard>
        </HasPermission>
        <HasPermission permission={props.icons.includes('note')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="note-add"
                onClick={() => {
                  props.setCurrentOperation(props.listItem.idOperation)
                }}
                style={{ alignSelf: "center", cursor: "pointer", height: "35px" }}
              />
            </TooltipText>
            <TooltipBox>
              {props.iconTooltips[587]}
            </TooltipBox>
          </TooltipCard>
        </HasPermission>

        <HasPermission permission={props.icons.includes('clone')}>
          <TooltipCard>
            <TooltipText>
              <Icon
                name="copy"
                title="Create Copy"
                onClick={() => props.createCopy(props.listItem.idProduct, props.listItem.idOperation)}
              />
            </TooltipText>
            <TooltipBox>
              {props.iconTooltips[602]}
            </TooltipBox>
          </TooltipCard>
        </HasPermission>
      </Row>
    </div >
  )
}

const icon = {
  cursor: "pointer",
  color: Colors.GRAY[6],
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
};

export default ListEnquiryButtons;